import { User as FireAuthUser } from 'firebase/auth';

/**
 * A user "needs email verification" if they signed up with email/password
 * (so they have an email but are not anonymous) and haven't verified that
 * email yet. Anonymous and provider-verified accounts (e.g. Google) skip
 * this check.
 */
export function needsEmailVerification(
  user: FireAuthUser | null | undefined
): boolean {
  if (!user) {
    return false;
  }
  return !user.isAnonymous && !!user.email && !user.emailVerified;
}
